import DeliveryMethodStepInfoCard from './DeliveryMethodStepInfoCard';

export default DeliveryMethodStepInfoCard;
